import React, { useEffect } from "react";
import Header from "../Components/Header/Header";
import AboutComp from "../Components/About/AboutComp";
import Footer from "../Components/Footer/Footer";

const AboutPage = () => {
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
  }, []);

  return (
    <>
      <Header />
      <AboutComp />
      <Footer />
    </>
  );
};

export default AboutPage;
